// removed by extract-text-webpack-plugin
module.exports = {"reset":"c3_c4","button":"c3_bp c3_c4","primary":"c3_c5 c3_bp c3_c4"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Button/styles.module.css
// module id = 302
// module chunks = 27